import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  MAX_TAX_RATE,
  MIN_TAX_RATE,
  clampTaxRate,
  useFederalTaxRate,
} from "hooks/useFederalTaxRate";

/**
 * Federal tax rate for the strategy report, persisted in localStorage and
 * sent along with the Calculate request.
 */
const StrategyFederalTaxSetting = () => {
  const [federalTaxRate, setFederalTaxRate] = useFederalTaxRate();
  const [inputValue, setInputValue] = useState(String(federalTaxRate));

  // Keep the field in step with the stored value (another component may
  // change it through the same hook).
  useEffect(() => {
    setInputValue(String(federalTaxRate));
  }, [federalTaxRate]);

  // Committed on blur/Enter rather than per keystroke, so clamping never
  // fights with typing ("1" on its way to "17" is not a 1% rate).
  const commitInputValue = () => {
    const parsed = Number(inputValue);
    if (inputValue.trim() === "" || !Number.isFinite(parsed)) {
      setInputValue(String(federalTaxRate));
      return;
    }
    const clamped = clampTaxRate(parsed);
    setFederalTaxRate(clamped);
    setInputValue(String(clamped));
  };

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Federal tax for strategy report
      </Typography>
      <TextField
        label="Federal tax"
        size="small"
        type="number"
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        onBlur={commitInputValue}
        onKeyDown={(event) => {
          if (event.key === "Enter") commitInputValue();
        }}
        inputProps={{ min: MIN_TAX_RATE, max: MAX_TAX_RATE, step: 0.1 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
    </Box>
  );
};

export default StrategyFederalTaxSetting;
